export const FIND_PLAY_BY_ID_COMPLETED = "project/plays/findPlayByIdCompleted";
export const FIND_PLAYS_BY_USER_ID_COMPLETED = "project/plays/findPlaysByUserIdCompleted";
export const FIND_PLAYS_BY_TEAM_ID_COMPLETED = "project/plays/findPlaysByTeamIdCompleted";
export const FIND_PLAYS_BY_TYPE_COMPLETED = "project/plays/findPlaysByTypeCompleted";
export const ADD_PLAY_COMPLETED = "project/plays/addPlayCompleted";
export const ADD_PLAY_TO_TEAM_COMPLETED = "project/plays/addPlayToTeamCompleted";
export const UPDATE_PLAY_COMPLETED = "project/plays/updatePlayCompleted";
export const REMOVE_PLAY_TO_TEAM_COMPLETED = "project/plays/removePlayToTeamCompleted";
export const REMOVE_PLAY_COMPLETED = "project/plays/removePlayCompleted";